<template>
  <div>
    <el-row>
      <el-col :span="8" class="setting-box">
        <span class="setTitle"><i style="color:red;">* </i>{{ $t("message.dataWedge.ProfileName") }}</span>
        <el-input size="small" disabled value="Scan Demo"></el-input>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle"><i style="color:red;">* </i>{{ $t("message.dataWedge.ConfigurationFileDescription") }}</span>
        <el-input size="small" disabled :value="$t('message.dataWedge.scandemo_pa_set')"></el-input>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.EnableConfigurationFile") }}</span>
        <el-select size="small"  v-model="scanComData.enable">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 应用程序 -->
    <el-row v-show="comtitle != 'Scan Demo'">
      <el-col :span="24">
        <span class="font-title">{{
          $t("message.dataWedge.Application")
        }}</span>
      </el-col>
      <el-col :span="24">
        <span class="small-font">{{
          $t("message.dataWedge.AssociateApps")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.AssociateAppsFile") }}</span>
        <el-button type="text" @click="openAPPDialog">{{
          $t("message.dataWedge.add")
        }}</el-button>
      </el-col>
    </el-row>
    <!-- 悬浮按钮 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{
          $t("message.dataWedge.FloatingButton")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.ActivateFloatingButton") }}</span>
        <el-select
          size="small"
          
          v-model="scanComData.floatButton.isEnable"
        >
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.DefauleButton") }}</span>
        <el-select size="small" v-model="scanComData.floatButton.showPattern">
          <el-option
            :label="$t('message.dataWedge.ButtonMode')"
            :value="0"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.ButtonOnlyMode')"
            :value="1"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.FullScreen')"
            :value="2"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.InitialPositionOfButton") }}</span>
        <el-input-number
          :min="0"
          :max="100"
          size="small"
          style="width: 100%"
          v-model="scanComData.floatButton.pos"
        ></el-input-number>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.TriggerScanWaitTime") }}</span>
        <el-input
          size="small"
          v-model="scanComData.floatButton.scanWaitTime"
        ></el-input>
      </el-col>
    </el-row>
    <!-- 条码输入 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{
          $t("message.dataWedge.BarCodeInput")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.SelectScanner") }}</span>
        <el-input
          size="small"
          disabled
          :value="$t('message.dataWedge.ScanningHead')"
        ></el-input>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.TriggerScanningMode") }}</span>
        <el-select size="small" v-model="scanComData.triggerMode"  @change="handleChangeTriggerMode">
          <el-option
            :label="$t('message.dataWedge.RaiseHandToStop')"
            :value="1"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.SingleScan')"
            :value="2"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.LiftHandScan')"
            :value="3"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.ScanWithTwoPress')"
            :value="4"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.PressAgainToStop')"
            :value="5"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.ContinuousLightEmission')"
            :value="6"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.CLRaiseHandToStop')"
            :value="7"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.MultiBarcodeScanning')"
            :value="8"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.ReportWithRaiseHand')"
            :value="8"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 扫描参数 -->
    <el-row>
      <el-col :span="24">
        <span class="secondfont-title">{{
          $t("message.dataWedge.ScanParameterConfiguration")
        }}</span>
      </el-col>
      <el-row style="width: 95%; margin-bottom: 20px; margin-top: 20px">
        <el-col :span="24">
          <el-collapse>
            <!-- 解码器 -->
            <el-collapse-item name="1">
              <template slot="title">
                <span class="code-font">{{
                  $t("message.dataWedge.decoder")
                }}</span>
              </template>
              <!-- 条码 -->
              <div>
                <!-- 基本参数设置 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">{{$t("message.applySettings.Other")}}</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.basicSettings.aimPrefix")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="scanComData.scanSettings.decoderParamsObjs['17']"
                    >
                      <el-option label="only gs1-128" :value="2"></el-option>
                      <el-option label="all" :value="1"></el-option>
                      <el-option label="close" :value="0"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.basicSettings.GS1")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="scanComData.scanSettings.decoderParamsObjs['16']"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- code128 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Code 128</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Code 128</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['289']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">ISBT 128</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['292']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code128.minimumBarcode")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['290']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code128.maximumBarcode")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['291']
                      "
                    ></el-input-number>
                  </el-col>

                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">GS1 128</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['293']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code128.quietZone")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['295']
                      "
                    >
                      <el-option label="0" :value="0"></el-option>
                      <el-option label="1" :value="1"></el-option>
                      <el-option label="2" :value="2"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code128.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['899']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.code128.normalBarcode')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.code128.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t(
                        "message.scanningToolMsg.code128.decodingRateEnhancement"
                      )
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['929']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- UPC/EAN -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">UPC/EAN</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">UPC-A</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['257']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">UPC-E</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['258']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">UPC-E1</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['259']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">EAN-8</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['260']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">EAN-13</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['261']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.transmitUPCA")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['263']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.transmitUPCE")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['264']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.transmitEAN13")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['266']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.transmitEAN8")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['267']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCAPlusPrefix")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['268']
                      "
                    >
                      <el-option
                        :label="$t('message.scanningToolMsg.UPC.doNotAdd')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.UPC.addSystemCharactersOnly'
                          )
                        "
                        :value="1"
                      ></el-option>
                      <el-option
                        label="添加国家编号与系统字符"
                        :value="2"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCEPlusPrefix")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['269']
                      "
                    >
                      <el-option
                        :label="$t('message.scanningToolMsg.UPC.doNotAdd')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.UPC.addSystemCharactersOnly'
                          )
                        "
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCEExtension")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['275']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCAAdditional2")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['276']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCAAdditional5")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['277']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCEAdditional2")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['278']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.UPCEAdditional5")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['279']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.EAN13Additional2")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['280']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.EAN13Additional5")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['281']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.EAN8Additional2")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['282']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.EAN8Additional5")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['283']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['898']
                      "
                    >
                      <el-option
                        :label="$t('message.scanningToolMsg.UPC.normalBarcode')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.UPC.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.UPC.decodingRateEnhancement")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['928']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- Code39 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Code 39</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Code 39</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['305']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Code 39 FULL ASCII</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['307']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.minimum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="48"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['310']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.maximum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="48"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['311']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.transmissionCheckCode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['312']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.checkCode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['313']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.code39Character")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['314']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code39.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['900']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.code39.normalBarcode')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.code39.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t(
                        "message.scanningToolMsg.code39.decodingRateEnhancement"
                      )
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['930']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- code93 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Code 93</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Code 93</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['321']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code93.minimum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['322']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code93.maximum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['323']
                      "
                    ></el-input-number>
                  </el-col>

                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code93.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['902']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.code93.normalBarcode')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.code93.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- code 11 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Code 11</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Code 11</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['337']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code11.minimum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['338']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code11.maximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['339']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.code11.transmissionCheckCode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['341']
                      "
                    >
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.code11.twoCheckBitsAndTransmit'
                          )
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.code11.oneCheckBitsAndTransmit'
                          )
                        "
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.code11.twoWithoutTransmit'
                          )
                        "
                        :value="2"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.code11.oneWithoutTransmit'
                          )
                        "
                        :value="3"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.code11.notcheck')"
                        :value="4"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- interleaved 2 of 5 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Interleaved 2 of 5</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Interleaved 2 of 5</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['353']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Interleaved2Of5.minimum")
                    }}</span>
                    <el-input-number
                      :min="2"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['354']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Interleaved2Of5.maximum")
                    }}</span>
                    <el-input-number
                      :min="2"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['355']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Interleaved2Of5.checkCode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['356']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.Interleaved2Of5.null')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.Interleaved2Of5.CheckNoTransmit'
                          )
                        "
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.Interleaved2Of5.CheckAndTransmit'
                          )
                        "
                        :value="2"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Interleaved2Of5.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['901']
                      "
                    >
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.Interleaved2Of5.normalBarcode'
                          )
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.Interleaved2Of5.nbrb')
                        "
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- codabar -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Codabar</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Codabar</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['401']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Codabar.minimum")
                    }}</span>
                    <el-input-number
                      :min="2"
                      :max="60"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['402']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Codabar.maximum")
                    }}</span>
                    <el-input-number
                      :min="2"
                      :max="60"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['403']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Codabar.startStopBit")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['404']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Codabar.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['904']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.Codabar.normalBarcode')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.Codabar.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- NEC 2 of 5 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">NEC 2 of 5</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">NEC 2 of 5</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['641']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.NEC2Of5.minimum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['642']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.NEC2Of5.maximum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['643']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- MSI -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">MSI</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">MSI</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['513']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.scanningToolMsg.MSI.minimum") }}</span>
                    <el-input-number
                      :min="4"
                      :max="48"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['514']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.scanningToolMsg.MSI.maximum") }}</span>
                    <el-input-number
                      :min="4"
                      :max="48"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['515']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- RSS -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">RSS</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">RSS-14</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['529']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.RSS.restriction")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['530']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.RSS.extension")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['531']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- QR -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">QR</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">QR Code</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['545']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.scanningToolMsg.QR.minimum") }}</span>
                    <el-input-number
                      :min="1"
                      :max="7089"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['546']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.scanningToolMsg.QR.maximum") }}</span>
                    <el-input-number
                      :min="1"
                      :max="7089"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['547']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">QR Inverse</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['548']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">MicroQR</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['549']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">QR Mirror</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['550']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">MicroQRInverse</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['551']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- Data Matrix -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Data Matrix</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.DataMatrix.dataMatrix")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['561']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.DataMatrix.normalBarcode')
                        "
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'message.scanningToolMsg.DataMatrix.inverseBarcode'
                          )
                        "
                        :value="2"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.DataMatrix.nbrb')"
                        :value="3"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.DataMatrix.minimum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="3166"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['562']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.DataMatrix.maximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="3166"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['563']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- China post -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">China Post</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">China Post</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['577']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.ChinaPost.minimum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['578']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.ChinaPost.maximum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['579']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- Matrix 2 of 5 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Matrix 2 of 5</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Matrix 2 of 5</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['593']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Matrix2Of5.Matrix2Of5minimum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['594']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Matrix2Of5.Matrix2Of5maximum")
                    }}</span>
                    <el-input-number
                      :min="4"
                      :max="80"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['595']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- Composite -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Composite</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle"
                      >{{ $t("message.scanningToolMsg.Composite.hybrid") }}
                    </span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['836']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- PDF417 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">PDF417</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">PDF417</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['705']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.PDF417.PDF417minimum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="2750"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['706']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.PDF417.PDF417maximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="2750"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['707']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.PDF417.negativeMode")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['903']
                      "
                    >
                      <el-option
                        :label="
                          $t('message.scanningToolMsg.PDF417.normalBarcode')
                        "
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.scanningToolMsg.PDF417.nbrb')"
                        :value="1"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t(
                        "message.scanningToolMsg.PDF417.decodingRateEnhancement"
                      )
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['931']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- MicroPDF417 -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">MicroPDF417</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">MicroPDF417</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['721']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t(
                        "message.scanningToolMsg.MicroPDF417.MicroPDF417minimum"
                      )
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="2750"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['722']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t(
                        "message.scanningToolMsg.MicroPDF417.MicroPDF417maximum"
                      )
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="2750"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['723']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- MaxiCode -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">MaxiCode</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">MaxiCode</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['737']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.MaxiCode.MaxiCodemaximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="150"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['739']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- Aztec -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Aztec</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Aztec</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['753']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Aztec.Aztecminimum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="3832"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['754']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Aztec.Aztecmaximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="3832"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['755']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- Codablock F -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Codablock F</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Codablock F</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['769']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.CodablockF.CodablockFminimum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="2048"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['770']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.CodablockF.CodablockFmaximum")
                    }}</span>
                    <el-input-number
                      :min="0"
                      :max="2048"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['771']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- Telepen -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Telepen</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Telepen</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['785']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Telepen.Telepenminimum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="60"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['786']
                      "
                    ></el-input-number>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.Telepen.Telepenmaximum")
                    }}</span>
                    <el-input-number
                      :min="1"
                      :max="60"
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['787']
                      "
                    ></el-input-number>
                  </el-col>
                </el-row>
                <!-- OCR -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">OCR</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">OCR</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['817']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.OCR.templateSelection")
                    }}</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['818']
                      "
                    >
                      <el-option label="User" :value="1"></el-option>
                      <el-option label="Passport" :value="2"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box" v-show="scanComData.scanSettings.decoderParamsObjs['818']==1">
                    <span class="setTitle">{{
                      $t("message.scanningToolMsg.OCR.OCRValue")
                    }}</span>
                    <el-input size="small" v-model="scanComData.scanSettings.ocrTemplate"></el-input>
                  </el-col>
                </el-row>
                <!-- Hanxin code -->
                <el-row>
                  <el-col :span="24">
                    <span class="small-font">Hanxin code</span>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">Hanxin code</span>
                    <el-select
                      size="small"
                      v-model="
                        scanComData.scanSettings.decoderParamsObjs['881']
                      "
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
            <!-- 多条码参数 -->
            <el-collapse-item name="2">
              <template slot="title">
                <span class="code-font">{{
                  $t("message.dataWedge.MultipleBarcodeParameters")
                }}</span>
              </template>
              <div>
                <el-row>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.EnableMultiBarcodeScan")
                    }}</span>
                    <el-select
                      size="small"
                      
                      v-model="
                        scanComData.scanSettings.isNormalCodeSplicingOpen
                      "
                       @change="handeleChangeisNormalCodeSplicingOpen"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.DisplayMultipleBarcodeCounts")
                    }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.showMultiCodeScanFloat"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.NumberScanEachTime")
                    }}</span>
                    <el-input
                      size="small"
                      v-model="scanComData.scanSettings.decoderParamsObjs['913']"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.MultiReadTime") }}</span>
                    <el-input
                      size="small"
                      v-model="scanComData.scanSettings.decoderParamsObjs['915']"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.MultiBarcodeSplicing")
                    }}</span>
                    <el-select
                      size="small"
                      
                      filterable
                      allow-create
                      v-model="scanComData.scanSettings.normalCodeSeparator"
                      @clear="scanComData.scanSettings.normalCodeSeparator=null"
                    >
                    <el-option value=";" label=";"></el-option>
            <el-option value="," label=","></el-option>
            <el-option value="" :label="$t('message.applySettings.NoSeparator')"></el-option>
            <el-option value=" " :label="$t('message.applySettings.Space')"></el-option>
            <el-option value="\n" :label="$t('message.applySettings.LineBreak')"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
            <!-- 读取器参数 -->
            <el-collapse-item name="3">
              <template slot="title">
                <span class="code-font">{{
                  $t("message.dataWedge.ReaderParameters")
                }}</span>
              </template>
              <div>
                <el-row>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.CharacterSetConfiguration")
                    }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.charSet"
                    >
                      <el-option label="AutoDetect" :value="0"></el-option>
                      <el-option label="GBK" :value="1"></el-option>
                      <el-option label="GB2312" :value="2"></el-option>
                      <el-option label="UTF-8" :value="3"></el-option>
                      <el-option label="BIG5" :value="4"></el-option>
                      <el-option label="SJIS" :value="5"></el-option>
                      <el-option label="EUC_JP" :value="6"></el-option>
                      <el-option label="ISO8859_1" :value="7"></el-option>
                      <el-option label="WINDOWS_874" :value="8"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.QuasiCenterMode") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.decoderParamsObjs['14']"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.FillLightSwitch") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.decoderParamsObjs['906']"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.Exposure") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.decoderParamsObjs['13']"
                    >
                      <el-option label="Auto" :value="0"></el-option>
                      <el-option label="Low" :value="1"></el-option>
                      <el-option label="Mid" :value="2"></el-option>
                      <el-option label="High" :value="3"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.LowQualityDecoding")
                    }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.decoderParamsObjs['4']"
                    >
                      <el-option
                        :label="$t('message.dataWedge.WorkLevel1')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.WorkLevel2')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.WorkLevel3')"
                        :value="2"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
            <!-- 扫描参数 -->
            <el-collapse-item name="4">
              <template slot="title">
                <span class="code-font">{{
                  $t("message.dataWedge.ScanParameters")
                }}</span>
              </template>
              <div>
                <el-row>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.ScanSound") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.isScanSound"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.ScanVolumeType") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.scanSoundCtl"
                    >
                      <el-option
                        :label="$t('message.dataWedge.UsingMediaVolume')"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.UsingCallVolume')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.dataWedge.UsingRingtonesAndCallVolume')
                        "
                        :value="2"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.UsingAlarmVolume')"
                        :value="3"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.ScanningVibration") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.isScanVibrate"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.ScanningPromptLight")
                    }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.isScanLed"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.ScanTimeout") }}</span>
                    <el-input
                      size="small"
                      v-model="scanComData.scanSettings.decoderParamsObjs['23']"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.DPMMode") }}</span>
                    <el-select
                      size="small"
                      
                      v-model="scanComData.scanSettings.decoderParamsObjs['897']"
                    >
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="0"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-row>
    <!-- Intent 输出 -->
    <el-row>
      <el-row>
        <el-col :span="24">
          <span class="font-title">{{
            $t("message.dataWedge.IntentOutput")
          }}</span>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.EnableIntentOutput") }}</span>
          <el-select
            size="small"
            
            v-model="scanComData.intentOutputConfig.enable"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              :value="false"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.BroadcastAction") }}</span>
          <el-input
            size="small"
            v-model="scanComData.intentOutputConfig.broadCastName"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.BroadcastDataLabel") }}</span>
          <el-input
            size="small"
            v-model="scanComData.intentOutputConfig.broadCastTag"
          ></el-input>
        </el-col>
      </el-row>
      <!-- 基本数据格式化 -->
      <el-row>
        <el-col :span="24">
          <span class="secondfont-title">{{
            $t("message.dataWedge.BasicDataFormatting")
          }}</span>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.PrefixData") }}</span>
          <el-input
            size="small"
            v-model="scanComData.intentOutputConfig.basicFormat.prefix"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.SuffixData") }}</span>
          <el-input
            size="small"
            v-model="scanComData.intentOutputConfig.basicFormat.suffix"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.ConvertInvisibleCharacters") }}</span>
          <el-select
            size="small"
            
            v-model="
              scanComData.intentOutputConfig.basicFormat.convertBlankChar
            "
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              :value="false"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.SendInHexFormat") }}</span>
          <el-select
            size="small"
            
            v-model="scanComData.intentOutputConfig.basicFormat.sendByHex"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              :value="false"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 高级数据格式化 -->
      <el-row>
        <el-col :span="24">
          <span class="secondfont-title">{{
            $t("message.dataWedge.AdvancedDataFormatting")
          }}</span>
          <el-button
            style="margin-bottom: 20px; margin-left: 50px"
            size="small"
            type="primary"
            @click.native="openAddIntentRule"
          >
            {{ $t("message.dataWedge.AddRules") }}
          </el-button>
        </el-col>
      </el-row>
      <el-row style="width: 95%; margin-bottom: 20px; margin-top: 20px">
        <el-col :span="24">
          <el-collapse accordion>
            <el-collapse-item
              v-for="(i, index) in addIntentRuleArr"
              :key="index"
              @click.native="openIntentCollapse(index)"
            >
              <template slot="title">
                <span class="code-font">{{ i.title }}</span>
              </template>
              <div>
                <el-row>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.EnableThisRule") }}</span>
                    <el-select size="small"  v-model="i.enable">
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.StringToCheck") }}</span>
                    <el-input
                      size="small"
                      v-model="i.strNeedChecked"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.ApplicableBarcodeTypes")
                    }}</span>
                     <el-select size="small" multiple v-model="i.codeTypeFilterCopy">
                      <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value"></el-option>
                    </el-select>
                  </el-col>
                  <!-- 数据删除 -->
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.DataDeletion")
                    }}</span>
                    <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.DeleteRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.DataDeletion") }}</span>
                    <el-select
                      size="small"
                      v-model="i.delChar" multiple
                    >
                      <el-option
                        :label="$t('message.dataWedge.Space')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.DeleteLeading0')"
                        :value="2"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.dataWedge.FilterInvisibleCharacters')
                        "
                        :value="3"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.dataWedge.DeleteSpecifiedCharacters')
                        "
                        :value="4"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col
                    :span="8"
                    class="setting-box"
                    v-show="i.delChar.includes(4)"
                  >
                    <span class="setTitle">{{
                      $t("message.dataWedge.DeleteSpecifiedCharacters")
                    }}</span>
                    <el-input
                      size="small"
                      v-model="i.delCharValue"
                    ></el-input>
                  </el-col>
                 
                  <!-- 字符替换 -->
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.CharacterReplacement")
                    }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.ReplaceRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.applySettings.characterSubstitutionSettings")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openIntentStringDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                  <!-- 条码截取 -->
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.BarcodeCapture")
                    }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.TruncateRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.applySettings.BarcodeTruncation")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openIntentBarTruDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                    <!-- 条码过滤 -->
                    <el-col :span="24">
                    <span class="small-font">{{ $t('message.dataWedge.BarcodeFiltering') }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.FilterRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.BarcodeFiltering")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openInterFilterCodeDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                   <!-- 结束字符 -->
                   <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.EndCharacter")
                    }}</span>
                      <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.EndCharRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <!-- <span class="setTitle">{{ $t("message.dataWedge.EndCharacter") }}</span> -->
                    <el-button @click="addEndChar('ENTER',i.endChars)">ENTER</el-button>
                    <el-button @click="addEndChar('TAB',i.endChars)">TAB</el-button>
                    <el-button @click="addEndChar('SPACE',i.endChars)">SPACE</el-button>
                    <el-button @click="addEndChar('CR_LF',i.endChars)">CR_LF</el-button>
                  </el-col>
                  <el-col :span="24">
                    <el-tag style="margin:0 5px 5px 0;"
                      v-for="(v,j) in i.endChars"
                      :key="j"
                      closable
                      @close="handleClose(j,i.endChars)"
                      type="">
                      {{v}}
                    </el-tag>
                  </el-col>
                  <el-col :span="24"></el-col>
                  <el-col :span="4" class="setting-box">
                    <el-button
                      type="primary"
                      size="small"
                      @click="submitIntentRules(index)"
                      >{{ $t("message.dataWedge.save") }}</el-button
                    >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      @click="deleteIntentRule(index)"
                      size="small"
                      >{{ $t("message.dataWedge.delete") }}</el-button
                    >
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-row>
    <!-- IP输出 -->
    <el-row>
      <el-row>
        <el-col :span="24">
          <span class="font-title">{{ $t("message.dataWedge.IPOutput") }}</span>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.EnableIPOutput") }}</span>
          <el-select
            size="small"
            
            v-model="scanComData.ipOutputConfig.enable"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              value="false"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.IPAddress") }}</span>
          <el-input
            size="small"
            v-model="scanComData.ipOutputConfig.address"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.Port") }}</span>
          <el-input
            size="small"
            v-model="scanComData.ipOutputConfig.port"
          ></el-input>
        </el-col>
      </el-row>
      <!-- 基本数据格式化 -->
      <el-row>
        <el-col :span="24">
          <span class="secondfont-title">{{
            $t("message.dataWedge.BasicDataFormatting")
          }}</span>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.PrefixData") }}</span>
          <el-input
            size="small"
            v-model="scanComData.ipOutputConfig.basicFormat.prefix"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.SuffixData") }}</span>
          <el-input
            size="small"
            v-model="scanComData.ipOutputConfig.basicFormat.suffix"
          ></el-input>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.ConvertInvisibleCharacters") }}</span>
          <el-select
            size="small"
            
            v-model="scanComData.ipOutputConfig.basicFormat.convertBlankChar"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              :value="false"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="setting-box">
          <span class="setTitle">{{ $t("message.dataWedge.SendInHexFormat") }}</span>
          <el-select
            size="small"
            
            v-model="scanComData.ipOutputConfig.basicFormat.sendByHex"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.open')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.switchSelect.close')"
              :value="false"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 高级数据格式化 -->
      <el-row>
        <el-col :span="24">
          <span class="secondfont-title">{{
            $t("message.dataWedge.AdvancedDataFormatting")
          }}</span>
          <el-button
            style="margin-bottom: 20px; margin-left: 50px"
            size="small"
            type="primary"
            @click.native="openAddIPRule"
          >
            {{ $t("message.dataWedge.AddRules") }}
          </el-button>
        </el-col>
      </el-row>
      <el-row style="width: 95%; margin-bottom: 20px; margin-top: 20px">
        <el-col :span="24">
          <el-collapse accordion>
            <el-collapse-item
              v-for="(i, index) in addIPRuleArr"
              :key="index"
              @click.native="openIpCollapse(index)"
            >
              <template slot="title">
                <span class="code-font">{{ i.title }}</span>
              </template>
              <div>
                <el-row>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.EnableThisRule") }}</span>
                    <el-select size="small"  v-model="i.enable">
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.open')"
                        :value="true"
                      ></el-option>
                      <el-option
                        :label="$t('message.systemMsg.switchSelect.close')"
                        :value="false"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.StringToCheck") }}</span>
                    <el-input
                      size="small"
                      v-model="i.strNeedChecked"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.ApplicableBarcodeTypes")
                    }}</span>
                    <el-select size="small" multiple v-model="i.codeTypeFilterCopy">
                      <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.DataDeletion")
                    }}</span>
                    <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.DeleteRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{ $t("message.dataWedge.DataDeletion") }}</span>
                    <el-select size="small" v-model="i.delChar" multiple>
                      <el-option
                        :label="$t('message.dataWedge.Space')"
                        :value="1"
                      ></el-option>
                      <el-option
                        :label="$t('message.dataWedge.DeleteLeading0')"
                        :value="2"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.dataWedge.FilterInvisibleCharacters')
                        "
                        :value="3"
                      ></el-option>
                      <el-option
                        :label="
                          $t('message.dataWedge.DeleteSpecifiedCharacters')
                        "
                        :value="4"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col
                    :span="8"
                    class="setting-box"
                    v-show="i.delChar.includes(4)"
                  >
                    <span class="setTitle">{{
                      $t("message.dataWedge.DeleteSpecifiedCharacters")
                    }}</span>
                    <el-input
                      size="small"
                      v-model="i.delCharValue"
                    ></el-input>
                  </el-col>
                 
                 
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.CharacterReplacement")
                    }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.ReplaceRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.applySettings.characterSubstitutionSettings")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openIpStringDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.BarcodeCapture")
                    }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.TruncateRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.applySettings.BarcodeTruncation")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openIpBarTruDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                   <!-- 条码过滤 -->
                   <el-col :span="24">
                    <span class="small-font">{{ $t('message.dataWedge.BarcodeFiltering') }}</span>
                     <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.FilterRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <span class="setTitle">{{
                      $t("message.dataWedge.BarcodeFiltering")
                    }}</span>
                    <el-button
                      type="text"
                      @click="openIPFilterCodeDialog(index)"
                      >{{ $t("message.applySettings.setUp") }}</el-button
                    >
                  </el-col>
                  <el-col :span="24">
                    <span class="small-font">{{
                      $t("message.dataWedge.EndCharacter")
                    }}</span>
                      <span style="display:inline-block;margin:0 10px 0 10px;">{{$t("message.dataWedge.order")}}</span>
                     <el-select v-model="i.indexs.EndCharRuleIndex" :placeholder="$t('message.dataWedge.Select')" size="small" class="min-width-select" @change="handleChangeIndex(i.indexs,$event)">
                      <el-option v-for="item in indexOption" :label="item.label" :value='item.label' :key=item.value></el-option>
                  </el-select>
                  </el-col>
                  <el-col :span="8" class="setting-box">
                    <!-- <span class="setTitle">{{ $t("message.dataWedge.EndCharacter") }}</span> -->
                    <el-button @click="addEndChar('ENTER',i.endChars)">ENTER</el-button>
                    <el-button @click="addEndChar('TAB',i.endChars)">TAB</el-button>
                    <el-button @click="addEndChar('SPACE',i.endChars)">SPACE</el-button>
                    <el-button @click="addEndChar('CR_LF',i.endChars)">CR_LF</el-button>
                  </el-col>
                  <el-col :span="24">
                    <el-tag style="margin:0 5px 5px 0;"
                      v-for="(v,j) in i.endChars"
                      :key="j"
                      closable
                      @close="handleClose(j,i.endChars)"
                      type="">
                      {{v}}
                    </el-tag>
                  </el-col>
                  <el-col :span="24"></el-col>
                  <el-col :span="4" class="setting-box">
                    <el-button
                      type="primary"
                      size="small"
                      @click="submitIpRules(index)"
                      >{{ $t("message.dataWedge.save") }}</el-button
                    >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      size="small"
                      @click="deleteIPRule(index)"
                      >{{ $t("message.dataWedge.delete") }}</el-button
                    >
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-row>
    <!-- 新增intent规则 -->
    <el-dialog
      :title="$t('message.dataWedge.NewRule')"
      :visible.sync="intentRuleDialog"
      width="30%"
    >
      <el-form>
        <el-form-item
          :label="$t('message.dataWedge.RuleName')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="newIntent_title"
            autocomplete="off"
            :placeholder="$t('message.dataWedge.EnterRuleName')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd('intent')">{{
          $t("message.dataWedge.cancel")
        }}</el-button>
        <el-button type="primary" @click="addIntentRule">{{
          $t("message.dataWedge.submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增IP规则 -->
    <el-dialog
      :title="$t('message.dataWedge.NewRule')"
      :visible.sync="ipRuleDialog"
      width="30%"
    >
      <el-form>
        <el-form-item
          :label="$t('message.dataWedge.RuleName')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="newIP_title"
            autocomplete="off"
            :placeholder="$t('message.dataWedge.EnterRuleName')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd('ip')">{{
          $t("message.dataWedge.cancel")
        }}</el-button>
        <el-button type="primary" @click="addIPRule">{{
          $t("message.dataWedge.submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!--  ===============intent字符替换========================== -->
    <el-dialog
      :title="$t('message.applySettings.CharacterSubstitution')"
      :visible.sync="intentStrDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="intentStrDialogClosed"
    >
      <div style="width: 100%">
        <el-button
          type="text"
          size="small"
          icon="el-icon-circle-plus-outline"
          @click="addIntentChangeStr"
          >{{ $t("message.applySettings.add") }}</el-button
        >
      </div>
      <el-table border :data="intentChangeStr">
        <el-table-column
          prop="id"
          :label="$t('message.applySettings.index')"
          width="80"
          type="index"
          align="center"
        />
        <el-table-column
          prop="source"
          align="center"
          :label="$t('message.applySettings.SourceCharacter')"
        >
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.source }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.source"
              maxlength="1"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="replace"
          align="center"
          :label="$t('message.applySettings.ReplaceCharacter')"
        >
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.replace }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.replace"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.applySettings.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              v-show="scope.row.isEdit"
              @click="okIntentChangeStr(scope.row)"
              >{{ $t("message.applySettings.Submit") }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              @click="editIntentChangeStr(scope.row)"
              v-show="!scope.row.isEdit"
            ></el-button>
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="delIntentChangeStr(scope.row)"
              v-show="!scope.row.isEdit"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitIntentStr">{{
          $t("message.applySettings.Submit")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- intent字符替换 -->
    <!-- intent条码截断 start-->
    <el-dialog
      :title="$t('message.applySettings.BarcodeTruncation')"
      :visible.sync="IntentBarcodeTruDialog"
      width="40%"
      @close="IntentSplitCloseDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="150px" :model="intentSpliteBarcodeCopy">
        <el-form-item :label="$t('message.applySettings.BarcodeTruncation')">
          <el-radio-group
            v-model="intentSpliteBarcodeCopy.mode"
            @change="modeChange(this.intentSpliteBarcodeCopy)"
          >
            <el-radio :label="0">{{
              $t("message.applySettings.IndexMode")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("message.applySettings.CharacterMode")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form
        v-show="intentSpliteBarcodeCopy.mode === 0"
        label-width="120px"
        style="width: 90%"
        :model="intentSpliteBarcodeCopy"
        ref="splitForm1"
        :rules="spliteRules1"
      >
        <el-form-item
          :label="$t('message.applySettings.StartIndex')"
          prop="startIndex"
        >
          <el-input
            v-model="intentSpliteBarcodeCopy.startIndex"
            :placeholder="$t('message.messageMsg.numBig0')"
            :min="1"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.applySettings.EndIndex')"
          prop="endIndex"
        >
          <el-input
            v-model="intentSpliteBarcodeCopy.endIndex"
            :placeholder="$t('message.messageMsg.numBig0')"
            :min="1"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        label-width="120px"
        v-show="intentSpliteBarcodeCopy.mode === 1"
        style="width: 90%"
        :model="intentSpliteBarcodeCopy"
        ref="splitForm2"
        :rules="spliteRules2"
      >
        <el-form-item
          :label="$t('message.applySettings.StartCharacter')"
          prop="startChar"
        >
          <el-input
            v-model="intentSpliteBarcodeCopy.startChar"
            :placeholder="$t('message.messageMsg.inputSingleChar')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.applySettings.EndCharacter')"
          prop="endChar"
        >
          <el-input
            v-model="intentSpliteBarcodeCopy.endChar"
            :placeholder="$t('message.messageMsg.inputSingleChar')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitIntentBar">{{
          $t("message.applySettings.Submit")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- intent条码截断 end -->
    <!--========== ip========== -->
    <el-dialog
      :title="$t('message.applySettings.CharacterSubstitution')"
      :visible.sync="ipStrDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="ipStrDialogClosed"
    >
      <div style="width: 100%">
        <el-button
          type="text"
          size="small"
          icon="el-icon-circle-plus-outline"
          @click="addIpChangeStr"
          >{{ $t("message.applySettings.add") }}</el-button
        >
      </div>
      <el-table border :data="ipChangeStr">
        <el-table-column
          prop="id"
          :label="$t('message.applySettings.index')"
          width="80"
          type="index"
          align="center"
        />
        <el-table-column
          prop="source"
          align="center"
          :label="$t('message.applySettings.SourceCharacter')"
        >
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.source }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.source"
              maxlength="1"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="replace"
          align="center"
          :label="$t('message.applySettings.ReplaceCharacter')"
        >
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.replace }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.replace"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.applySettings.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              v-show="scope.row.isEdit"
              @click="okIpChangeStr(scope.row)"
              >{{ $t("message.applySettings.Submit") }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              @click="editIpChangeStr(scope.row)"
              v-show="!scope.row.isEdit"
            ></el-button>
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="delIpChangeStr(scope.row)"
              v-show="!scope.row.isEdit"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitIpStr">{{
          $t("message.applySettings.Submit")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- ip字符替换 -->
    <!-- ip条码截断 start-->
    <el-dialog
      :title="$t('message.applySettings.BarcodeTruncation')"
      :visible.sync="IpBarcodeTruDialog"
      width="40%"
      @close="IpSplitCloseDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="150px" :model="ipSpliteBarcodeCopy">
        <el-form-item :label="$t('message.applySettings.BarcodeTruncation')">
          <el-radio-group
            v-model="ipSpliteBarcodeCopy.mode"
            @change="modeChange(this.ipSpliteBarcodeCopy)"
          >
            <el-radio :label="0">{{
              $t("message.applySettings.IndexMode")
            }}</el-radio>
            <el-radio :label="1">{{
              $t("message.applySettings.CharacterMode")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form
        v-show="ipSpliteBarcodeCopy.mode === 0"
        label-width="120px"
        style="width: 90%"
        :model="ipSpliteBarcodeCopy"
        ref="ipsplitForm1"
        :rules="spliteRules1"
      >
        <el-form-item
          :label="$t('message.applySettings.StartIndex')"
          prop="startIndex"
        >
          <el-input
            v-model="ipSpliteBarcodeCopy.startIndex"
            :placeholder="$t('message.messageMsg.numBig0')"
            :min="1"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.applySettings.EndIndex')"
          prop="endIndex"
        >
          <el-input
            v-model="ipSpliteBarcodeCopy.endIndex"
            :placeholder="$t('message.messageMsg.numBig0')"
            :min="1"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        label-width="120px"
        v-show="ipSpliteBarcodeCopy.mode === 1"
        style="width: 90%"
        :model="ipSpliteBarcodeCopy"
        ref="ipsplitForm2"
        :rules="spliteRules2"
      >
        <el-form-item
          :label="$t('message.applySettings.StartCharacter')"
          prop="startChar"
        >
          <el-input
            v-model="ipSpliteBarcodeCopy.startChar"
            :placeholder="$t('message.messageMsg.inputSingleChar')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.applySettings.EndCharacter')"
          prop="endChar"
        >
          <el-input
            v-model="ipSpliteBarcodeCopy.endChar"
            :placeholder="$t('message.messageMsg.inputSingleChar')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitIpBar">{{
          $t("message.applySettings.Submit")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- ip条码截断 end -->
    <!-- 新增应用 -->
    <el-dialog :visible.sync="appListDialogVisible" width="40%">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">{{
          $t("message.appDesktopMsg.Submit")
        }}</el-button>
      </span>
    </el-dialog>

     <!-- intent条码过滤 -->
     <el-dialog   
     :title="$t('message.dataWedge.BarcodeFiltering')"
      :visible.sync="intentfilterCodeDialog"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close='cancelIntentFilterCode'
      >
      <el-form :model="intentFilterCopy" label-width="100px">
        <el-form-item :label="$t('message.dataWedge.001')">
          <el-radio-group v-model="intentFilterCopy.codeTypeIsOut">
            <el-radio :label="true">{{$t('message.dataWedge.002')}}</el-radio>
            <el-radio :label="false">{{$t('message.dataWedge.003')}}</el-radio>
          </el-radio-group>
        </el-form-item>  
        <el-form-item :label="$t('message.dataWedge.004')">
          <el-select v-model="intentFilterCopy.subCodeTypeFilter" :placeholder="$t('message.dataWedge.008')" multiple  @change="handleIntentSelectAll">
            <el-option v-for="item in filterOptions" :label="item.label" :value="item.value" :key=item.value></el-option>
          </el-select>
      </el-form-item>
      <el-form-item :label="$t('message.dataWedge.005')">
          <el-radio-group v-model="intentFilterCopy.lengthIsOut">
            <el-radio :label="true">{{$t('message.dataWedge.002')}}</el-radio>
            <el-radio :label="false">{{$t('message.dataWedge.003')}}</el-radio>
          </el-radio-group>
        </el-form-item>  
        <el-form-item :label="$t('message.dataWedge.006')">
          <el-input style="width:220px" v-model="intentFilterCopy.length" :placeholder="$t('message.dataWedge.009')" @input="handleIntentLengthInput"></el-input>
        </el-form-item>
          <span style='color:red;fontSize:12px'>*</span><span style='fontSize:12px'>{{$t('message.dataWedge.007')}}</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelIntentFilterCode">{{$t('message.dataWedge.cancel')}}</el-button>
        <el-button type="primary" @click="saveIntentFilterCodeData">{{$t('message.dataWedge.submit')}}</el-button>
      </span>
     </el-dialog>
      <!-- ip条码过滤 -->
     <el-dialog   
     :title="$t('message.dataWedge.BarcodeFiltering')"
      :visible.sync="ipfilterCodeDialog"
      width="35%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close='cancelIpFilterCode'
      >
      <el-form :model="ipFilterCopy" label-width="100px">
        <el-form-item :label="$t('message.dataWedge.001')">
          <el-radio-group v-model="ipFilterCopy.codeTypeIsOut">
            <el-radio :label="true">{{$t('message.dataWedge.002')}}</el-radio>
            <el-radio :label="false">{{$t('message.dataWedge.003')}}</el-radio>
          </el-radio-group>
        </el-form-item>  
        <el-form-item :label="$t('message.dataWedge.004')">
          <el-select v-model="ipFilterCopy.subCodeTypeFilter" :placeholder="$t('message.dataWedge.008')" multiple @change="handleIPSelectAll">
            <el-option v-for="item in filterOptions" :label="item.label" :value="item.value" :key=item.value></el-option>
          </el-select>
      </el-form-item>
      <el-form-item :label="$t('message.dataWedge.005')">
          <el-radio-group v-model="ipFilterCopy.lengthIsOut">
            <el-radio :label="true">{{$t('message.dataWedge.002')}}</el-radio>
            <el-radio :label="false">{{$t('message.dataWedge.003')}}</el-radio>
          </el-radio-group>
        </el-form-item>  
        <el-form-item :label="$t('message.dataWedge.006')">
          <el-input style="width:220px" v-model="ipFilterCopy.length" :placeholder="$t('message.dataWedge.009')" @input="handleIpLengthInput"></el-input>
        </el-form-item>
          <span style='color:red;fontSize:12px'>*</span><span style='fontSize:12px'>{{$t('message.dataWedge.007')}}</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelIpFilterCode">{{$t('message.dataWedge.cancel')}}</el-button>
        <el-button type="primary" @click="saveIPFilterCodeData">{{$t('message.dataWedge.submit')}}</el-button>
      </span>
     </el-dialog>
  </div>
</template>

<script>
import { nanoid } from "nanoid";
export default {
  props: {
    scanData: { type: Object },
    comtitle: { type: String },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("message.messageMsg.InputStartPosition")));
      } else if (value<=0) {
        callback(new Error(this.$t("message.messageMsg.numBig0")));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("message.messageMsg.inputEndPosition")));
      } else if (value<=0) {
        callback(new Error(this.$t("message.messageMsg.numBig0")));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("message.messageMsg.inputStartChar")));
      } else if (!/^.$/.test(value)) {
        callback(new Error(this.$t("message.messageMsg.inputSingleChar")));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("message.messageMsg.inputEndChar")));
      } else if (!/^.$/.test(value)) {
        callback(new Error(this.$t("message.messageMsg.inputSingleChar")));
      } else {
        callback();
      }
    };
    return {
      spliteRules1: {
        startIndex: [{ validator: validatePass, trigger: "blur" }],
        endIndex: [{ validator: validatePass1, trigger: "blur" }],
      },
      spliteRules2: {
        startChar: [{ validator: validatePass2, trigger: "blur" }],
        endChar: [{ validator: validatePass3, trigger: "blur" }],
      },
      // ======================intent数据============================
      addIntentRuleArr: [],
      intentSelectedIndex: null,
      intentRuleDialog: false,
      newIntent_title: "",
      sub_intentAttr_rules: {
        delChar: [],
        delCharValue: "",
      },
      // intent字符替换
      intentChangeStr: [],
      intentStrDialogVisible: false,
      // intent条码截取
      IntentBarcodeTruDialog: false,
      intentSpliteBarcodeCopy: {
        endChar: "",
        endIndex: "",
        mode: -1,
        startChar: "",
        startIndex: "",
        des: "设置指定条码截取",
        enable: false,
        title: "条码截取",
        type: "TruncateRule",
      },
      // 结束字符
      intentEndCharsObj: {
        endChars: [],
        des: "设置指定结束字符",
        enable: false,
        title: "结束字符",
      },
      // ==========================IP数据======================
      addIPRuleArr: [],
      newIP_title: "",
      sub_ipAttr_rules: {
        delChar: [],
        delCharValue: "",
      },
      // ip-结束字符
      ipEndCharsObj: {
        endChars: [],
        des: "设置指定结束字符",
        enable: false,
        title: "结束字符",
      },
      // ip-字符
      ipChangeStr: [],
      ipStrDialogVisible: false,
      // ip-条码截取
      IpBarcodeTruDialog: false,
      ipSpliteBarcodeCopy: {
        endChar: "",
        endIndex: "",
        mode: -1,
        startChar: "",
        startIndex: "",
        des: "设置指定条码截取",
        enable: false,
        title: "条码截取",
        type: "TruncateRule",
      },
      ipSelectedIndex: null,
      formLabelWidth: "120px",
      ipRuleDialog: false,
      // 添加应用
      appListDialogVisible: false,
      appListData: [],
      options:[
        {label:'Code 128',value:'Code 128'},
        {label:'UPC/EAN',value:'UPC/EAN'},
        {label:'Code 39',value:'Code 39'},
        {label:'Code 93',value:'Code 93'},
        {label:'Code 11',value:'Code 11'},
        {label:'Interleaved 2 of 5',value:'Interleaved 2 of 5'},
        {label:'Codabar',value:'Codabar'},
        {label:'NEC 2 of 5',value:'NEC 2 of 5'},
        {label:'MSI',value:'MSI'},
        {label:'RSS',value:'RSS'},
        {label:'QR',value:'QR'},
        {label:'Data Matrix',value:'Data Matrix'},
        {label:'China Post',value:'China Post'},
        {label:'Matrix 2 of 5',value:'Matrix 2 of 5'},
        {label:'Composite',value:'Composite'},
        {label:'PDF417',value:'PDF417'},
        {label:'MicroPDF417',value:'MicroPDF417'},
        {label:'MaxiCode',value:'MaxiCode'},
        {label:'Aztec',value:'Aztec'},
        {label:'Codablock F',value:'Codablock F'},
        {label:'Telepen',value:'Telepen'},
        {label:'OCR',value:'OCR'},
        {label:'Hanxin code',value:'Hanxin code'},
      ],
       // 条码过滤数据
      ipfilterCodeDialog:false,
      intentfilterCodeDialog:false,
      intentFilterIndex:null,
      ipFilterIndex:null,
      ipFilterCopy:{
        des: "条码过滤",
              enable: false,
              title: "条码过滤",
              type: "FilterRule",
              lengthIsOut: true,
              length: '',
              codeTypeIsOut: true,
              subCodeTypeFilter: []
      },
      intentFilterCopy:{
        des: "条码过滤",
              enable: false,
              title: "条码过滤",
              type: "FilterRule",
              lengthIsOut: true,
              length: '',
              codeTypeIsOut: true,
              subCodeTypeFilter: []
      },
      filterOptions:[
        {label:'ALL',value:'ALL'},
        {label:'GS1应用标识分隔符',value:'GS1应用标识分隔符'},
        {label:'Code 128',value:'Code 128'},
        {label:'UPC/EAN',value:'UPC/EAN'},
        {label:'Code 39',value:'Code 39'},
        {label:'Code 93',value:'Code 93'},
        {label:'Code 11',value:'Code 11'},
        {label:'Interleaved 2 of 5',value:'Interleaved 2 of 5'},
        {label:'Codabar',value:'Codabar'},
        {label:'NEC 2 of 5',value:'NEC 2 of 5'},
        {label:'MSI',value:'MSI'},
        {label:'RSS',value:'RSS'},
        {label:'QR',value:'QR'},
        {label:'Data Matrix',value:'Data Matrix'},
        {label:'China Post',value:'China Post'},
        {label:'Matrix 2 of 5',value:'Matrix 2 of 5'},
      ],
      indexOption:[
        {label:'1',value:1},
        {label:'2',value:2},
        {label:'3',value:3},
        {label:'4',value:4},
        {label:'5',value:5},
      ]
    };
  },
  computed: {
    scanComData: {
      get() {
        return this.scanData;
      },
      set(newVal) {
        this.$emit("update:scanData", newVal);
      },
    },
  },
  methods: {
     // 最后一个enter展示自动提交
     showCheckbox(arr){
        // 获取数组中最后一个元素
      const lastElement = arr[arr.length - 1];
      // 如果最后一个元素是 "enter"，则返回 true，否则返回 false
      return lastElement === 'ENTER';
      },
      // 添加多个endChar
      addEndChar(str,arr){
      arr.push(str);
    },
    handleClose(i,arr){
      arr.splice(i,1);
    },
     // 确保index的值唯一
     handleChangeIndex(obj,val){
      let count=0;
      // 遍历 indexs 对象，检查值是否等于 val
      // 如果超过一个值等于 val，则报错
      for (let key in obj) {
          if (obj[key] === val) {
              count++;
              if (count > 1) {
                 this.$message.error(this.$t("message.dataWedge.orderValues"));
                  for (let k in obj) {
                      if (obj[k] === val) {
                          obj[k]=null;
                      }
                  }
                  break;
              }
          }
      }
    },
    //  根据 scanData.triggerMode 的值动态生成第二个 <el-select> 的选项列表
    handleChangeTriggerMode(val){
      if(val===8||val===8){
        this.scanData.scanSettings.isNormalCodeSplicingOpen=true;
      }else{
        this.scanData.scanSettings.isNormalCodeSplicingOpen='';
      }
      this.$forceUpdate();
    },
    // 启用多条码扫描
    handeleChangeisNormalCodeSplicingOpen(val){
      if(val===''||val===false){
        this.scanData.triggerMode='';
      this.$forceUpdate();
      }
      if(val===true){
        this.scanData.triggerMode=8;
        this.$forceUpdate();
      }
    },
    translantStr(obj) {
      let profileItemInfos = [...obj];
      const newArry = [];
      profileItemInfos.forEach((item) => {
        delete item.isEdit;
        const newItem = { ...item };
        newArry.push(newItem);
      });
      let arr = {};
      arr.profileItemInfos = newArry;
      arr.enable = true;
      arr.des = "设置指定字符替换";
      arr.title = "字符替换";
      arr.type = "ReplaceRule";
      return arr;
    },
    // =================字符替换end========================
    modeChange(obj) {
      if (obj.mode === 0) {
        obj.startChar = "";
        obj.endChar = "";
        obj.enable = true;
      } else if (obj.mode === 1) {
        obj.startIndex = 0;
        obj.endIndex = 0;
        obj.enable = true;
      } else if (obj.mode === -1) {
        obj.startChar = "";
        obj.endChar = "";
        obj.startIndex = 0;
        obj.endIndex = 0;
        obj.enable = false;
      }
    },
    //条码截断end
    cancelAdd(str) {
      if (str == "intent") {
        this.intentRuleDialog = false;
        this.newIntentRule.name = "";
      }
      if (str == "ip") {
        this.ipRuleDialog = false;
        this.newIntent_title = "";
      }
    },
    // 保存数据删除规则
    saveDelCharRule(val, str) {
      let sub_delChar_rule = {
        filterInvisibleChars: false,
        pre0: false,
        space: false,
        specChar: null,
        enable: true,
        title: "数据删除",
        des: "设置指定删除字符串",
        type: "DeleteRule"
      };
      // 遍历 val 数组（所选选项的值）
      val.forEach((option) => {
        switch (option) {
          case 1:
            sub_delChar_rule.space = true;
            break;
          case 2:
            sub_delChar_rule.pre0 = true;
            break;
          case 3:
            sub_delChar_rule.filterInvisibleChars = true;
            break;
          case 4:
            sub_delChar_rule.specChar = str || "";
            break;
        } });
        sub_delChar_rule.enable = val.length > 0;
      return sub_delChar_rule;
    },
     // 回显数据删除规则
     showDelCharRule(obj){
      let subRules={
        delChar:[],
        delCharValue:''
      }
      obj.forEach((sub_item) => {
                if (sub_item.type === "DeleteRule") {
                  // 设置 delChar
                  if (sub_item.space) {
                    subRules.delChar.push(1); // 添加 1 到数组中
                  }
                  if (sub_item.pre0) {
                    subRules.delChar.push(2); // 添加 2 到数组中
                  }
                  if (sub_item.filterInvisibleChars) {
                    subRules.delChar.push(3); // 添加 3 到数组中
                  }
                  if (sub_item.specChar != null) {
                    subRules.delChar.push(4); // 添加 4 到数组中
                    subRules.delCharValue = sub_item.specChar; // 设置 delCharValue
                  }
                }
              })
              return subRules;
    },
    // ========================intent规则操作====================
    openIntentCollapse(i) {
      this.intentSelectedIndex = i;
    },
    // 保存intent规则
    submitIntentRules(i) {
      let rule = JSON.parse(JSON.stringify(this.addIntentRuleArr[i]))
      let sub_delChar_rule = this.saveDelCharRule(
        rule.delChar,
        rule.delCharValue
      );
      rule.des = rule.enable ? "已启用" : "未启用";
      // 反选条码
      if(rule.codeTypeFilterCopy.length>0){
        this.options.forEach(option => {
        if (!rule.codeTypeFilterCopy.includes(option.value)) {
          rule.codeTypeFilter.push(option.value);
        }
      });
      }
     // 删除属性并触发响应式更新
     if(rule.delChar.length>0){
       let index3 = rule.subRules.findIndex((v) => v.type === "DeleteRule");
        if(index3!=-1){
          rule.subRules.splice(index3, 1);
          rule.subRules.push(sub_delChar_rule);
        }else{
          rule.subRules.push(sub_delChar_rule);
        }
     }
      // 删除外层endChar，将endChar提交给subRules里面的结束字符位置
      if(rule.endChars.length>0){
        let index2 = rule.subRules.findIndex((v) => v.type === "EndCharRule");
        if (index2 != -1) {
          if(rule.endChars.length>0){
            rule.subRules[index2].endChars=rule.endChars;
            rule.subRules[index2].enable=true;
          }else{
            rule.subRules[index2].enable=false;
          }
        }
      }
      this.$delete(rule, 'endChars');
      this.$delete(rule, 'delChar');
      this.$delete(rule, 'delCharValue');
      let newRule=this.changeArrIndex(rule);

      let sourceArr = [
        ...this.scanComData.intentOutputConfig.advanceFormat.rules,
      ];
      let index = sourceArr.findIndex(
        (v) => v.id === this.addIntentRuleArr[i].id
      );
      if (index == -1) {
        // 新增
        this.scanComData.intentOutputConfig.advanceFormat.rules.push(newRule);
        this.$message.success(this.$t("message.dataWedge.success"));
      } else {
        // 修改
        this.scanComData.intentOutputConfig.advanceFormat.rules.splice(
          index,
          1
        );
        this.scanComData.intentOutputConfig.advanceFormat.rules.push(newRule);
        this.$message.success(this.$t("message.dataWedge.success"));

      }
      this.ruleDialog = false;
    },
    // 打开intent弹框
    openAddIntentRule() {
      this.intentRuleDialog = true;
      this.newIntent_title = "";
    },
    // 添加Intent规则
    addIntentRule() {
      if(this.newIntent_title){
      this.addIntentRuleArr.push({
        id: nanoid(),
        title: this.newIntent_title,
        codeTypeFilter: [],
        strNeedChecked: null,
        enable: null,
        des: "",
        subRules: [
        {
          des: "设置指定删除字符串",
          enable: false,
          filterInvisibleChars: false,
          pre0: false,
          space: false,
          specChar: null,
          title: "数据删除",
          type: "DeleteRule"
         },
          {
            profileItemInfos: [],
            des: "设置指定字符替换",
            enable: false,
            title: "字符替换",
            type: "ReplaceRule",
          },
          {
            endChar: "",
            endIndex: 0,
            mode: -1,
            startChar: "",
            startIndex: 0,
            des: "设置指定条码截取",
            enable: false,
            title: "条码截取",
            type: "TruncateRule",
          }, {
              des: "条码过滤",
              enable: false,
              title: "条码过滤",
              type: "FilterRule",
              lengthIsOut: false,
              length: '',
              codeTypeIsOut: false,
              subCodeTypeFilter: []
            },
          {
            endChars: [],
            des: "设置指定结束字符",
            enable: false,
            title: "结束字符",
            type: "EndCharRule",
          }
          ],
          delChar: [],
          delCharValue :"",
          endChars: [],
          indexs:{
            DeleteRuleIndex:null,
            ReplaceRuleIndex:null,
            TruncateRuleIndex:null,
            EndCharRuleIndex:null,
            FilterRuleIndex:null,
          }
      });
      this.intentRuleDialog = false;
    }
      else{
        this.$message.error(this.$t("message.dataWedge.RequiredRuleName"))
      }
    },
    // intent-字符弹框打开
    openIntentStringDialog(i) {
      this.intentSelectedIndex = i;
      this.intentStrDialogVisible = true;
      const index = this.addIntentRuleArr[i].subRules.findIndex(
        (v) => v.type == "ReplaceRule"
      );
      if (index != -1) {
        this.intentChangeStr = [
          ...this.addIntentRuleArr[i].subRules[index].profileItemInfos,
        ].map((item) => {
          return { ...item, isEdit: false };
        });
      }
    },
    // intent-字符关闭
    intentStrDialogClosed() {
      if (this.intentChangeStr.length != 0) {
        this.intentChangeStr = this.intentChangeStr.filter((item) => {
          return item.isEdit != true;
        });
      }
    },
    // intent-字符添加
    addIntentChangeStr() {
      this.intentChangeStr.push({
        replace: "",
        isEdit: true,
        source: "",
      });
    },
    // 编辑intent
    editIntentChangeStr(data) {
      data.isEdit = true;
    },
    // 保存intent-字符
    okIntentChangeStr(data) {
      if (data.source != "") {
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.strNoEmpty"),
          type: "warning",
        });
      }
    },
    // 删除intent-字符
    delIntentChangeStr(data) {
      let i = this.intentChangeStr.indexOf(data);
      this.intentChangeStr.splice(i, 1);
    },
    // 提交intent-字符
    submitIntentStr() {
      if (this.intentChangeStr.length != 0) {
        let isEditStatus = this.intentChangeStr.some((i) => i.isEdit); // 是否编辑状态
        let isEmptySource = this.intentChangeStr.some((i) => i.source == ""); // 是否源数据为空
        if (isEditStatus) {
          if (!isEmptySource) {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.save"));
          } else {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.strNoEmpty"));
          }
        } else {
          this.intentStrDialogVisible = false;
          let res = this.translantStr(this.intentChangeStr);
          const index = this.addIntentRuleArr[
            this.intentSelectedIndex
          ].subRules.findIndex((v) => v.type == "ReplaceRule");
          if (index != -1) {
            this.addIntentRuleArr[this.intentSelectedIndex].subRules[index] =
              res;
            this.$message.success(this.$t("message.dataWedge.success"));
          } else {
            this.addIntentRuleArr[this.intentSelectedIndex].subRules[index] =
              res;
            this.$message.success(this.$t("message.dataWedge.success"));
          }
          this.intentChangeStr = [];
        }
      }
    },
    // intent-条码截取
    openIntentBarTruDialog(i) {
      this.intentSelectedIndex = i;
      this.IntentBarcodeTruDialog = true;
      const index = this.addIntentRuleArr[i].subRules.findIndex(
        (v) => v.type === "TruncateRule"
      );
      this.intentSpliteBarcodeCopy = {
        ...this.addIntentRuleArr[i].subRules[index],
      };
    },
    // intent-条码截取关闭
    IntentSplitCloseDialog() {
      this.$nextTick(() => {
        this.$refs["splitForm1"].clearValidate();
        this.$refs["splitForm2"].clearValidate();
      });
    },
    // intent-条码截取提交
    submitIntentBar() {
      const index = this.addIntentRuleArr[
        this.intentSelectedIndex
      ].subRules.findIndex((v) => v.type == "TruncateRule");
      if (this.intentSpliteBarcodeCopy.mode === 0) {
        this.$refs["splitForm1"].validate((valid) => {
          if (valid) {
            this.addIntentRuleArr[this.intentSelectedIndex].subRules[index] =
              this.intentSpliteBarcodeCopy;
            this.IntentBarcodeTruDialog = false;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          }
        });
      } else if (this.intentSpliteBarcodeCopy.mode === 1) {
        this.$refs["splitForm2"].validate((valid) => {
          if (valid) {
            this.addIntentRuleArr[this.intentSelectedIndex].subRules[index] =
              this.intentSpliteBarcodeCopy;
            this.IntentBarcodeTruDialog = false;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          }
        });
      }
    },
    // 删除intent规则
    deleteIntentRule(i) {
      this.$confirm(this.$t("message.dataWedge.WhetherDelete"), this.$t("message.dataWedge.Tips"), {
        confirmButtonText: this.$t("message.dataWedge.submit"),
          cancelButtonText: this.$t("message.dataWedge.cancel"),
        type: "warning",
      })
        .then(() => {
          this.addIntentRuleArr.splice(i, 1);
          this.scanComData.intentOutputConfig.advanceFormat.rules.splice(i, 1);

          this.$message({
            type: "success",
            message: this.$t("message.dataWedge.AlreadyRemoved"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message:  this.$t("message.dataWedge.DeleteCanceled"),
          });
        });
    },
    // ======================ip规则操作=======================
    openAddIPRule() {
      this.ipRuleDialog = true;
      this.newIP_title = "";
    },
    addIPRule() {
      if(this.newIP_title){
        this.addIPRuleArr.push({
          id: nanoid(),
          title: this.newIP_title,
          codeTypeFilter: [],
          strNeedChecked: null,
          enable: null,
          des: "",
          subRules: [
          {
            des: "设置指定删除字符串",
            enable: false,
            filterInvisibleChars: false,
            pre0: false,
            space: false,
            specChar: null,
            title: "数据删除",
            type: "DeleteRule"
           },
            {
              profileItemInfos: [],
              des: "设置指定字符替换",
              enable: false,
              title: "字符替换",
              type: "ReplaceRule",
            },
            {
              endChar: "",
              endIndex: 0,
              mode: -1,
              startChar: "",
              startIndex: 0,
              des: "设置指定条码截取",
              enable: false,
              title: "条码截取",
              type: "TruncateRule",
            }, {
              des: "条码过滤",
              enable: false,
              title: "条码过滤",
              type: "FilterRule",
              lengthIsOut: false,
              length: '',
              codeTypeIsOut: false,
              subCodeTypeFilter: []
            },
            {
              endChars: [],
              des: "设置指定结束字符",
              enable: false,
              title: "结束字符",
              type: "EndCharRule",
            }
          ],
          delChar: [],
          delCharValue :"",
          endChars: [],
          indexs:{
            DeleteRuleIndex:null,
            ReplaceRuleIndex:null,
            TruncateRuleIndex:null,
            EndCharRuleIndex:null,
            FilterRuleIndex:null,
          }
        });
        this.ipRuleDialog = false;
      }
      else{
        this.$message.error(this.$t("message.dataWedge.RequiredRuleName"))
      }
    },
    deleteIPRule(i) {
      this.$confirm(
        this.$t("message.dataWedge.WhetherDelete"),
        this.$t("message.dataWedge.Tips"),
        {
          confirmButtonText: this.$t("message.dataWedge.submit"),
          cancelButtonText: this.$t("message.dataWedge.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.addIPRuleArr.splice(i, 1);
          this.scanComData.ipOutputConfig.advanceFormat.rules.splice(i, 1);
          this.$message({
            type: "success",
            message: this.$t("message.dataWedge.AlreadyRemoved"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.dataWedge.DeleteCanceled"),
          });
        });
    },
    openIpBarTruDialog(i) {
      this.ipSelectedIndex = i;
      this.IpBarcodeTruDialog = true;
      const index = this.addIPRuleArr[i].subRules.findIndex(
        (v) => v.type === "TruncateRule"
      );
      this.ipSpliteBarcodeCopy = {
        ...this.addIPRuleArr[i].subRules[index],
      };
    },
    openIpStringDialog(i) {
      this.ipSelectedIndex = i;
      this.ipStrDialogVisible = true;
      const index = this.addIPRuleArr[i].subRules.findIndex(
        (v) => v.type == "ReplaceRule"
      );
      if (index != -1) {
        this.ipChangeStr = [
          ...this.addIPRuleArr[i].subRules[index].profileItemInfos,
        ].map((item) => {
          return { ...item, isEdit: false };
        });
      }
    },
    submitIpRules(i) {
      let rule = JSON.parse(JSON.stringify(this.addIPRuleArr[i]))
      // 删除属性并触发响应式更新
       let sub_delChar_rule = this.saveDelCharRule(
         rule.delChar,
         rule.delCharValue
       );
       rule.des = rule.enable ? "已启用" : "未启用";
       // 反选条码
       if(rule.codeTypeFilterCopy.length>0){
        this.options.forEach(option => {
        if (!rule.codeTypeFilterCopy.includes(option.value)) {
          rule.codeTypeFilter.push(option.value);
        }
        
      });
      }
       let index3 = rule.subRules.findIndex((v) => v.type === "DeleteRule");
        if(index3!=-1){
          rule.subRules.splice(index3, 1);
          rule.subRules.push(sub_delChar_rule);
        }else{
          rule.subRules.push(sub_delChar_rule);
        }
     if(rule.endChars.length>0){
       // 删除外层endChar，将endChar提交给subRules里面的结束字符位置
       let index2 = rule.subRules.findIndex((v) => v.type === "EndCharRule");
       if (index2 != -1) {
         if(rule.endChars.length>0){
           rule.subRules[index2].endChars=rule.endChars;
           rule.subRules[index2].enable=true;
         }else{
           rule.subRules[index2].enable=false;
         }
       }
     }
      this.$delete(rule, 'endChars');
      this.$delete(rule, 'delChar');
      this.$delete(rule, 'delCharValue');
      let newRule=this.changeArrIndex(rule);

      let sourceArr = [...this.scanComData.ipOutputConfig.advanceFormat.rules];
      let index = sourceArr.findIndex((v) => v.id === this.addIPRuleArr[i].id);
      if (index == -1) {
        // 新增
        this.scanComData.ipOutputConfig.advanceFormat.rules.push(newRule);
        this.$message.closeAll();
        this.$message.success(this.$t("message.dataWedge.success"));

      } else {
        // 修改
        this.scanComData.ipOutputConfig.advanceFormat.rules.splice(index, 1);
        this.scanComData.ipOutputConfig.advanceFormat.rules.push(newRule);
        this.$message.closeAll();
        this.$message.success(this.$t("message.dataWedge.success"));

      }
      this.ipRuleDialog = false;
    },
    addIpChangeStr() {
      this.ipChangeStr.push({
        replace: "",
        isEdit: true,
        source: "",
      });
    },
    editIpChangeStr(data) {
      data.isEdit = true;
    },
    okIpChangeStr(data) {
      if (data.source != "") {
        data.isEdit = false;
      } else {
        this.$message.closeAll();
        this.$message({
          message: this.$t("message.messageMsg.strNoEmpty"),
          type: "warning",
        });
      }
    },
    delIpChangeStr(data) {
      let i = this.ipChangeStr.indexOf(data);
      this.ipChangeStr.splice(i, 1);
    },
    submitIpStr() {
      if (this.ipChangeStr.length != 0) {
        let isEditStatus = this.ipChangeStr.some((i) => i.isEdit); // 是否编辑状态
        let isEmptySource = this.ipChangeStr.some((i) => i.source == ""); // 是否源数据为空
        if (isEditStatus) {
          if (!isEmptySource) {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.save"));
          } else {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.strNoEmpty"));
          }
        } else {
          this.ipStrDialogVisible = false;
          let res = this.translantStr(this.ipChangeStr);
          const index = this.addIPRuleArr[
            this.ipSelectedIndex
          ].subRules.findIndex((v) => v.type == "ReplaceRule");
          if (index != -1) {
            this.addIPRuleArr[this.ipSelectedIndex].subRules[index] = res;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          } else {
            this.addIPRuleArr[this.ipSelectedIndex].subRules[index] = res;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          }
          this.ipChangeStr = [];
        }
      }
    },
    ipStrDialogClosed() {
      if (this.ipChangeStr.length != 0) {
        this.ipChangeStr = this.ipChangeStr.filter((item) => {
          return item.isEdit != true;
        });
      }
    },
    IpSplitCloseDialog() {
      this.$nextTick(() => {
        this.$refs["ipsplitForm1"].clearValidate();
        this.$refs["ipsplitForm2"].clearValidate();
      });
    },
    submitIpBar() {
      const index = this.addIPRuleArr[this.ipSelectedIndex].subRules.findIndex(
        (v) => v.type == "TruncateRule"
      );
      if (this.ipSpliteBarcodeCopy.mode === 0) {
        this.$refs["ipsplitForm1"].validate((valid) => {
          if (valid) {
            this.addIPRuleArr[this.ipSelectedIndex].subRules[index] =
              this.ipSpliteBarcodeCopy;
            this.IpBarcodeTruDialog = false;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          }
        });
      } else if (this.ipSpliteBarcodeCopy.mode === 1) {
        this.$refs["ipsplitForm2"].validate((valid) => {
          if (valid) {
            this.addIPRuleArr[this.ipSelectedIndex].subRules[index] =
              this.ipSpliteBarcodeCopy;
            this.IpBarcodeTruDialog = false;
            this.$message.closeAll();
            this.$message.success(this.$t("message.dataWedge.success"));
          }
        });
      }
    },
    // 展开ip折叠面板
    openIpCollapse(i) {
      this.ipSelectedIndex = i;
    },
    // 打开应用添加弹框
    openAPPDialog() {
      this.appListDialogVisible = true;
    },
    // 按照数据顺序改变位置
    changeArrIndex(obj){
      const { indexs, subRules } = obj;
      let hasNonNull = Object.values(indexs).some(value => value !== null);
      let tempArr = [];
      if (hasNonNull) {
          let nullIndices = Object.entries(indexs).filter(([key, value]) => value === null).map(([key]) => key);
          tempArr = subRules.filter(item => nullIndices.includes(item.type + 'Index'))
          let sortedIndices = Object.entries(indexs).filter(([key, value]) => value !== null).sort((a, b) => a[1] - b[1]);
          sortedIndices.forEach(([type, index]) => {
              let rule = subRules.find(rule => rule.type === type.replace('Index', ''));
              tempArr.splice(index-1, 0, rule);
          });
          obj.subRules = tempArr;
      }
      return obj
    },
    // 数据回显
    initData() {
      // intent值
      if (this.scanComData?.intentOutputConfig?.advanceFormat?.rules?.length) {
        let intentRuleArr =
          this.scanComData.intentOutputConfig.advanceFormat.rules;
        this.addIntentRuleArr = [...intentRuleArr];
        intentRuleArr.forEach((item) => {
          // 数据删除
          if (item.subRules.length) {
            let sub_rules = item.subRules;
            item.delChar=[];
            item.delCharValue='';
            item.endChars=[];
            sub_rules.forEach((sub_item) => {
              if (sub_item.type === "DeleteRule") {
                // 设置 delChar
                if (sub_item.space) {
                  item.delChar.push(1); // 添加 1 到数组中
                }
                if (sub_item.pre0) {
                  item.delChar.push(2); // 添加 2 到数组中
                }
                if (sub_item.filterInvisibleChars) {
                  item.delChar.push(3); // 添加 3 到数组中
                }
                if (sub_item.specChar != null) {
                  item.delChar.push(4); // 添加 4 到数组中
                  item.delCharValue = sub_item.specChar; // 设置 delCharValue
                }
              }
              if (sub_item.type === "ReplaceRule") {
                this.intentChangeStr = [...sub_item.profileItemInfos];
              }
              if (sub_item.type === "EndCharRule") {
                item.endChars = sub_item.endChars;
              }
            });
          }
        });
      }
      // ip值
      if (this.scanComData?.ipOutputConfig?.advanceFormat?.rules?.length) {
        let ipRuleArr = this.scanComData.ipOutputConfig.advanceFormat.rules;
        this.addIPRuleArr = [...ipRuleArr];
        ipRuleArr.forEach((item) => {
             // 数据删除
             if (item.subRules.length) {
            let sub_rules = item.subRules;
            item.delChar=[];
            item.delCharValue='';
            item.endChars=[];
            sub_rules.forEach((sub_item) => {
              if (sub_item.type === "DeleteRule") {
                // 设置 delChar
                if (sub_item.space) {
                  item.delChar.push(1); // 添加 1 到数组中
                }
                if (sub_item.pre0) {
                  item.delChar.push(2); // 添加 2 到数组中
                }
                if (sub_item.filterInvisibleChars) {
                  item.delChar.push(3); // 添加 3 到数组中
                }
                if (sub_item.specChar != null) {
                  item.delChar.push(4); // 添加 4 到数组中
                  item.delCharValue = sub_item.specChar; // 设置 delCharValue
                }
              }
              if (sub_item.type === "ReplaceRule") {
                this.ipChangeStr = [...sub_item.profileItemInfos];
              }
              if (sub_item.type === "EndCharRule") {
                item.endChars = sub_item.endChars;
              }
            });
          }
        });
      }
    },
     // 清空所有数据
    clearAllData(){
      this.addIntentRuleArr=[],
      this.intentSelectedIndex=null,
      this.addIPRuleArr=[],
      this.ipSelectedIndex=null,
      this.appListData=[]
    },
       // ip条码过滤
       openIPFilterCodeDialog(i){
      this.ipFilterIndex=i;
      this.ipfilterCodeDialog=true;
      const index = this.addIPRuleArr[i].subRules.findIndex(
        (v) => v.type === "FilterRule"
      );
      this.ipFilterCopy = { ...this.addIPRuleArr[i].subRules[index] };
    },
     // ip保存条码过滤
     saveIPFilterCodeData(){
      const index = this.addIPRuleArr[this.ipFilterIndex].subRules.findIndex(
        (v) => v.type == "FilterRule"
      );
        this.ipFilterCopy.enable=true;
        this.addIPRuleArr[this.ipFilterIndex].subRules[index] =this.ipFilterCopy;
        this.ipfilterCodeDialog = false;
       this.$message.success(this.$t("message.dataWedge.success"));
      },
       // intent条码过滤
      openInterFilterCodeDialog(i){
      this.intentFilterIndex=i;
      this.intentfilterCodeDialog=true;
      const index = this.addIntentRuleArr[i].subRules.findIndex(
        (v) => v.type === "FilterRule"
      );
      this.intentFilterCopy = { ...this.addIntentRuleArr[i].subRules[index] };
    },
     // intent保存条码过滤
     saveIntentFilterCodeData(){
      const index = this.addIntentRuleArr[this.intentFilterIndex].subRules.findIndex(
        (v) => v.type == "FilterRule"
      );
        this.intentFilterCopy.enable=true;
        this.addIntentRuleArr[this.intentFilterIndex].subRules[index] =this.intentFilterCopy;
        this.intentfilterCodeDialog = false;
       this.$message.success(this.$t("message.dataWedge.success"));
      },
       // intent取消条码过滤
       cancelIntentFilterCode(){
        this.intentfilterCodeDialog = false;
          this.intentFilterCopy={
                des: "条码过滤",
                enable: false,
                title: "条码过滤",
                type: "FilterRule",
                lengthIsOut: true,
                length: '',
                codeTypeIsOut: true,
                subCodeTypeFilter: []
          }
      },
      // ip取消条码过滤
      cancelIpFilterCode(){
        this.ipfilterCodeDialog = false;
          this.ipFilterCopy={
                des: "条码过滤",
                enable: false,
                title: "条码过滤",
                type: "FilterRule",
                lengthIsOut: true,
                length: '',
                codeTypeIsOut: true,
                subCodeTypeFilter: []
          };
      },
      handleIntentLengthInput(value){
        // 使用正则表达式过滤非数字字符
        this.intentFilterCopy.length = value.replace(/[^\d]/g, '');
          // 如果需要显示即时错误提示（可选）
          if (value !== this.intentFilterCopy.length) {
            this.$message.warning(this.$t('message.dataWedge.numberOnlyWarning'));
          }
      },
      handleIpLengthInput(value){
        // 使用正则表达式过滤非数字字符
        this.ipFilterCopy.length = value.replace(/[^\d]/g, '');
          // 如果需要显示即时错误提示（可选）
          if (value !== this.ipFilterCopy.length) {
            this.$message.warning(this.$t('message.dataWedge.numberOnlyWarning'));
          }
      },
  handleIPSelectAll(selected) {
     // 检查是否选中了全选选项 'ALL'
     const isAllSelected = selected.includes('ALL');
    
    // 获取所有子选项的值（排除全选选项）
    const allSubValues = this.filterOptions.map(item => item.value);
    
    if (isAllSelected) {
      // 如果当前已全选，点击后清空
      if (this.ipFilterCopy.subCodeTypeFilter.length === allSubValues.length) {
        this.ipFilterCopy.subCodeTypeFilter = [];
      } else {
        // 否则选中所有子选项
        this.ipFilterCopy.subCodeTypeFilter = allSubValues;
      }
      // 移除全选选项的标识 'ALL'
      this.ipFilterCopy.subCodeTypeFilter = this.ipFilterCopy.subCodeTypeFilter.filter(v => v !== 'ALL');
    } else {
      // 如果手动取消全选，确保不包含 'ALL'
      const hasAll = selected.includes('ALL');
      if (hasAll) {
        this.ipFilterCopy.subCodeTypeFilter = selected.filter(v => v !== 'ALL');
      }
    }
  },
  handleIntentSelectAll(selected) {
     // 检查是否选中了全选选项 'ALL'
     const isAllSelected = selected.includes('ALL');
    // 获取所有子选项的值（排除全选选项）
    const allSubValues = this.filterOptions.map(item => item.value);
    if (isAllSelected) {
      // 如果当前已全选，点击后清空
      if (this.intentFilterCopy.subCodeTypeFilter.length === allSubValues.length) {
        this.intentFilterCopy.subCodeTypeFilter = [];
      } else {
        // 否则选中所有子选项
        this.intentFilterCopy.subCodeTypeFilter = allSubValues;
      }
      // 移除全选选项的标识 'ALL'
      this.intentFilterCopy.subCodeTypeFilter = this.intentFilterCopy.subCodeTypeFilter.filter(v => v !== 'ALL');
    } else {
      // 如果手动取消全选，确保不包含 'ALL'
      const hasAll = selected.includes('ALL');
      if (hasAll) {
        this.intentFilterCopy.subCodeTypeFilter = selected.filter(v => v !== 'ALL');
      }
    }
  }
  },
  created() {
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.font-title {
  display: inline-block;
  width: 300px;
  border-left: 6px solid #409eff;
  padding-left: 10px;
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  margin: 0 0 10px 20px;
}

.setting-box {
  margin-left: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-family: "Microsoft YaHei";
  font-size: 14px;

  span {
    display: inline-block;
    margin-right: 20px;
    width: 270px;
    text-align: right;
    // 超出部分用...替换
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span:hover {
    overflow: visible;
    white-space: normal;
    width: 270px;
    position: relative; /* Keep the expanded text in place */
    z-index: 1; /* Ensure it appears above other content */
  }
  .setting-node {
    font-size: 14px;
    display: inline;
    margin-left: 5px;
  }

  .el-input {
    width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}


.setting-btns {
  width: 300px;
  float: right;
}

.wifi-addbox {
  width: 100%;
  margin-bottom: 10px;

  div {
    width: 220px;
    margin-right: 10px;
  }

  .el-input {
    width: 200px;
  }
}

.add-btns {
  border: 1px dashed #e4e7ed;
  text-align: center;
  padding: 3px;
  margin-top: 5px;
  border-radius: 3px;
}

.code-font {
  font-size: 14px;
  margin-left: 50px;
  color: #666666;
}

.switchcode-font {
  font-size: 14px;
  margin-left: 50px;
  margin-right: 10px;
  color: #666666;
}

.small-font {
  font-size: 12px;
  display: inline-block;
  // background-color: #d0e7ff;
  // color: white;
  padding: 5px;
  // border-radius: 3px;
  border-bottom: 1px solid #409eff;
  margin-left: 100px;
  margin-bottom: 10px;
}

.secondfont-title {
  display: inline-block;
  padding: 2px 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  font-family: "Microsoft YaHei";
  margin: 0 0 20px 20px;
  color: #666666;
  background-color: #d0e7ff;
}

.el-input--small .el-input__inner {
  height: 32px;
  margin-top: 5px;
  line-height: 32px;
}

.el-input--small .el-input__inner {
  height: 32px;
  margin-top: 5px;
  line-height: 32px;
}

#tag-box {
  width: auto;
  margin-left: 5px;
}

.tags-box {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-items: start;
  grid-row-gap: 10px;
}
.min-width-select{
    width: 100px;
}
</style>
